// User-scope permissions are explicit boolean columns. org_admin covers the org roster
// and group create/delete; group-scope permissions live on the group membership instead.
export type UserPermissionFlag = 'can_create_reports' | 'can_create_templates' | 'org_admin'

export enum UserStatus {
    ACTIVE = 1,
    REMOVED = 2,
    INACTIVE = 3,
}

export interface UserProfile {
    language: string | null // ISO 639-1, e.g. 'nl'
}

/**
 * An inactive user is offboarded: they may still sign in, but only to read what they
 * recorded while active, until those records expire (MD-1497). The backend enforces the
 * same policy; this only decides what the app renders.
 */
export const isReadOnly = (user: UserModel | null): boolean => user?.status === UserStatus.INACTIVE

export interface UserModel {
    accepted_agreement: boolean | null
    accepted_privacy_policy: boolean | null
    accepted_usage_instructions: boolean | null
    can_create_reports: boolean
    can_create_templates: boolean
    org_admin: boolean
    information_classification: string | null

    ff_chat: boolean
    ff_analytics: boolean
    profile: UserProfile
    id: string
    org_id: string | null
    name: string
    name_given?: string | null
    name_family?: string | null
    external_id: string
    status: number
}
